// extracted by mini-css-extract-plugin
export default {"body":"Website_body__wOsD7","header":"Website_header__anZh3","gobackBox":"Website_gobackBox__V7m-I","newsBox":"Website_newsBox__c9nIp"};